import React, { Component } from 'react';
import { withIonLifeCycle } from '@ionic/react';
import { BehaviorSubject } from 'rxjs';
import api, { onRefreshing } from '../../../../services/api';
import { formatDateApi } from '../../../../utils/formats';

import Card from '../../Card';
import SectionItemCurrency from '../../../Section/SectionItemCurrency';
import Divider from '../../../Divider';

const onSelect = new BehaviorSubject('');

class CardFinanceiroTotalizadores extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refreshing: false,
      period: '',
      data: {
        pagamentos: {},
        recebimentos: {},
        saldoFinanceiro: 0,
      },
    };
    this.subscriptionRefresh = null;
    this.subscriptionSelect = null;
    this.asyncRequest = null;
  }

  componentDidMount() {
    this.subscriptionRefresh = onRefreshing.subscribe(() => {
      const dataInicial = formatDateApi(new Date());
      const dataFinal = formatDateApi(new Date());
      onSelect.next({ dataInicial, dataFinal });
    });
    this.subscriptionSelect = onSelect.subscribe(data => {
      const { periodo, ...headers } = data;
      this.setState({ period: periodo });
      if (headers.dataInicial !== undefined || headers.dataFinal !== undefined) {
        this.setState({ refreshing: true });
        this.asyncRequest = api
          .get('/financeiro/totalizadores', { headers })
          .then(({ data }) => {
            this.asyncRequest = null;
            this.setState({ data, refreshing: false });
          });
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props?.periodo !== prevProps.periodo) {
      const headers = {};
      headers.dataInicial = this.props.dateRange.dataInicial;
      headers.dataFinal = this.props.dateRange.dataFinal;
      this.setState({ period: this.props.periodo });
      if (headers.dataInicial && headers.dataFinal) {
        this.setState({ refreshing: true });
        api.get('/financeiro/totalizadores', { headers }).then(({ data }) => {
          this.setState({ data, refreshing: false });
        });
      }
    }
  }

  componentWillUnmount() {
    if (this.subscriptionRefresh) this.subscriptionRefresh.unsubscribe();
    if (this.subscriptionSelect) this.subscriptionSelect.unsubscribe();
  }

  onChangeDate = ({ dataInicial, dataFinal, periodo }) => {
    onSelect.next({ dataInicial, dataFinal, periodo });
  };

  render() {
    const { period, data, refreshing } = this.state;
    return (
      <>
        <Card title="Financeiro" period={period} onChangeDate={this.onChangeDate}>
          <SectionItemCurrency
            title="Recebimentos"
            icon="recebimento"
            refreshing={refreshing}
            count={data.recebimentos.quantidade}
            total={data.recebimentos.valorTotal}
          />

          <SectionItemCurrency
            title="Pagamentos"
            icon="pagamento"
            refreshing={refreshing}
            count={data.pagamentos.quantidade}
            total={data.pagamentos.valorTotal}
          />

          <Divider />

          <SectionItemCurrency
            title="DIFERENÇA"
            style={{ paddingBottom: 50 }}
            refreshing={refreshing}
            total={data.saldoFinanceiro}
          />
        </Card>
      </>
    );
  }
}

export default withIonLifeCycle(CardFinanceiroTotalizadores);
